<template>
  <div class="sidebarOne-view">
    <div class="sidebarTop">
      {{title}}
    </div>
    <el-menu
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      background-color="#7D74A2"
      text-color="#fff"
      active-text-color="black"
      @select="select">
      <el-menu-item v-for="(item,index) in list" :key="index" :index="(item.id).toString()">
        <span slot="title">
          {{item.text}}
          <i class="el-icon-arrow-right"></i>
        </span>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'sidebarOne',
  props: {
    list: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    defaultActive: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    select (index, indexPath) {
      let list = this.list
      list.forEach(e => {
        if (e.id.toString() === indexPath[0]) {
          this.$emit('selectMenu', {
            id: e.id.toString(),
            text: e.text
          })
        }
      })
      // this.$emit('selectMenu', {
      //   id: this.list[index - 1].id,
      //   text: this.list[index - 1].text
      // })
    },
    thisPath () {
      // const path = this.$route.path
      // const self = this
      // this.list.forEach((e, i) => {
      //   if (path.indexOf(e.path) !== -1) {
      //     self.default_active = i.toString()
      //   }
      // })
    }
  },
  watch: {
    '$route': 'thisPath'
  },
  mounted () {
    // this.thisPath()
  }
}
</script>
<style lang="less" scoped>
  @fint-size: 14px;
  @width: 200px;
  @hoverColor: red;
  .sidebarOne-view{
    width: @width;
    ul{
      padding: 0;
      margin: 0;
      list-style: none;
      border-right: 1px solid #7D74A2 !important;
      border-left: 1px solid #7D74A2 !important;
      li{
        height: 76px;
        line-height: 76px;
        border-bottom: 1px solid #625b8a;
        span{
          i{
            font-size: 14px;
            float: right;
            line-height: 76px;
            color: white;
          }
        }
      }
      .is-active{
        background-color: white !important;
        text-align: center;
      }
    }
    .sidebarTop{
      background-color: #54536F;
      color: white;
      line-height: 40px;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 2px dashed white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/sidebar2/sidebar2.vue